import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const TrackingScripts = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    // Skip tracking on admin and portal pages
    const path = window.location.pathname;
    if (path.startsWith('/admin') || path.startsWith('/portal')) return;
    
    const fetchSettings = async () => {
      try {
        const res = await fetch(`${API_URL}/api/settings/public`);
        if (res.ok) {
          const data = await res.json();
          setSettings(data);
        }
      } catch (err) {
        console.debug('Failed to fetch tracking settings:', err);
      }
    };

    fetchSettings();
  }, []);

  useEffect(() => {
    if (!settings) return;

    // Inject Google Analytics 4
    if (settings.google_analytics_id) {
      // Check if already loaded
      if (!document.querySelector(`script[src*="googletagmanager.com/gtag"]`)) {
        const gtagScript = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${settings.google_analytics_id}`;
        document.head.appendChild(gtagScript);

        const gtagConfig = document.createElement('script');
        gtagConfig.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${settings.google_analytics_id}');
        `;
        document.head.appendChild(gtagConfig);
      }
    }

    // Inject Meta Pixel
    if (settings.meta_pixel_id) {
      // Check if already loaded
      if (!window.fbq) {
        const pixelScript = document.createElement('script');
        pixelScript.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${settings.meta_pixel_id}');
          fbq('track', 'PageView');
        `;
        document.head.appendChild(pixelScript);

        // Add noscript fallback
        const noscript = document.createElement('noscript');
        noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${settings.meta_pixel_id}&ev=PageView&noscript=1"/>`;
        document.body.appendChild(noscript);
      }
    }
  }, [settings]);

  return null; // This component doesn't render anything
};

export default TrackingScripts;
